module.exports = __webpack_public_path__ + "images/123_320.jpg";